import axios from 'CanExConfig/axios'

const endpoint = candidateId => `/api/candidate/v2/candidate_profiles/${candidateId}/coding_tests`

export const getCodingTest = async candidateId => {
  const response = await axios(endpoint(candidateId), {
    method: 'GET',
  })

  return response.data
}
